import { useParams } from "react-router-dom";
import { useGetRemittanceApplicationDetailQuery } from "../../../../store/queries/remittance";

const formatLabel = (key) =>
  key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());

const mapSectionData = (data) => {
  if (!data) return [];
  return Object.keys(data)
    .filter((key) => key !== "status" && key !== "order_number")
    .filter((key) => key !== "student_id" || data[key])
    .map((key) => ({
      label: formatLabel(key),
      value: data[key] ?? "---",
    }));
};

const useApplicationDetail = () => {
  const { remittanceID } = useParams();
  const { data: applicationData, isFetching } =
    useGetRemittanceApplicationDetailQuery({
      remittance_id: remittanceID,
    });

  const appData = applicationData?.data;

  const sections = appData
    ? Object.keys(appData)
        .filter((key) => typeof appData[key] === "object" && appData[key] !== null)
        .map((key) => ({
          title: formatLabel(key),
          data: mapSectionData(appData[key]),
        }))
    : [];

  return {
    sections,
    isFetching,
  };
};

export default useApplicationDetail;
